import { updateItems } from '@/mocks/homeData';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">最新更新</h2>
          <p className="text-sm text-foreground-500 mb-8">妖精动漫最新漫画章节更新动态速览</p>

          <div className="relative">
            <div className="absolute left-4 md:left-5 top-0 bottom-0 w-px bg-background-200" />

            <div className="space-y-5">
              {updateItems.map((item, i) => (
                <div key={i} className="relative flex gap-4 md:gap-5 pl-10 md:pl-12">
                  <div className={`absolute left-[13px] md:left-[15px] w-3 h-3 rounded-full border-2 ${
                    i === 0 ? 'bg-primary-500 border-primary-500' : 'bg-background-50 border-background-300'
                  }`} />

                  <div className="flex-1 bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                    <div className="flex flex-wrap items-center gap-2 mb-2">
                      <span className="px-2 py-0.5 text-xs font-medium bg-secondary-100/80 text-secondary-800 rounded-full whitespace-nowrap">
                        {item.tag}
                      </span>
                      <span className="text-xs text-foreground-400">{item.date}</span>
                    </div>
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs md:text-sm text-foreground-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}